import type { FormErrors } from '@zen/Components/Form/types';
import type { ListItemType } from '@zen/Components/VerticalList/ListItem';

import { type Container, emptyContainer, type RawContainer } from './types';

export const createTemplateListItems = (containerList: Container[]): ListItemType[] => {
  if (!containerList) return [];

  return containerList.map((container: Container) => ({
    id: String(container.id),
    label: container.number ? `${container.size}: ${container.number}` : container.size
  }));
};

export const formatDate = (date?: Date | null): string => {
  if (!date || isNaN(date.getTime())) {
    return 'before today';
  }

  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const getInvalidFieldCounts = (
  values: Record<string, Container>,
  errors: FormErrors<Record<string, Container>>
): Record<string, number> => {
  const missingCounts: Record<string, number> = {};

  const flattenErrors = (obj: unknown): string[] => {
    if (!obj) return [];
    if (typeof obj === 'string') return [obj];
    if (Array.isArray(obj)) return obj.flatMap(flattenErrors);
    if (typeof obj === 'object') return Object.values(obj).flatMap(flattenErrors);

    return [];
  };

  Object.keys(values).forEach((containerId) => {
    const containerErrors = errors[containerId] || {};

    missingCounts[containerId] = flattenErrors(containerErrors).length;
  });

  return missingCounts;
};

export const parseContainers = (containersArray: RawContainer[]) => {
  const containerRecords: Record<string, Container> = {};

  containersArray.forEach((container) => {
    if (container?.id) {
      containerRecords[container.id] = {
        ...emptyContainer,
        ...container,
        loose: { ...emptyContainer.loose, ...container.loose },
        hsCodes: Array.isArray(container.hsCodes)
          ? container.hsCodes
          : (container.hsCodes ?? '')
              .split(',')
              .map((c: string) => c.trim())
              .filter(Boolean)
      };
    }
  });

  return containerRecords;
};
